/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrReplaceGoal} from '../api'

export const useMutationCreateOrReplaceGoal = createReactQueryMutationHook('createOrReplaceGoal', createOrReplaceGoal)
